import {Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {Report, ReportTemplate} from '../types/models';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {ConstantsService} from './constants.service';
import {AccountPermissionsService} from './account-permissions.service';
import {CanDeactivate} from '@angular/router';
import {ReportGeneratorModalComponent} from '../views/report-generator/report-generator-modal/report-generator-modal.component';
import {Observable} from 'rxjs/Observable';
import {tap} from 'rxjs/operators';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';

declare const toastr: any;
declare const swal: any;
declare const $: any;

@Injectable()
export class ReportGeneratorService {
    isReportModalShow = false;
    isListShow = true;

    templateInTemplateModal: ReportTemplate;

    data = {
        allTemplates: {
            get: '/v1/report_templates.json?',
            data: [],
            total: null
        },
        allReports: {
            get: '/v1/reports.json?',
            data: [],
            total: null
        }
    };
    tabId = 'allTemplates';
    spinnerShow = true;
    showServiceUnavailable = false;
    buildings: Array<any> = [];
    buildingsForRead: Array<any> = [];
    buildingsForUpdate: Array<any> = [];
    buildingsForMultiselect: Array<any> = [];
    serviceName: string = 'report_builder';
    refreshInterval = null;
    copyingReport = false;
    viewOnlyMode = false;
    modalInfoWasChanged = false;
    showRuntimeConditionsModal = false;
    showCustomReportViewModal = false;
    showReportNameModal = false;
    reportInReportModal = null;

    constructor(
        public api: ApiClientService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService,
        public account: AccountPermissionsService
    ) {
        this.api.onLogout.subscribe(() => this.buildings = []);
    }

    getData() {
        this.getDataByQueryParams().subscribe();
    }

    getDataByQueryParams() {
        this.showServiceUnavailable = false;
        this.spinnerShow = true;
        const tabId = this.urlService.queryParams['tab'];
        const url = this.data[tabId].get;
        const queryParams = this.urlService.getQueryParamsString();

        return this.api.getJson('domainReportGenerator', `${url}${queryParams}`)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity(
                    (item) => {
                        if (item.building && item.building.bdId) {
                            item.building.id = item.building.bdId;
                        }
                        const mutated = this.account.addPermissionsToEntity(item, this.serviceName);
                        if (tabId == 'allTemplates') {
                            return ReportTemplate.fromExistingData(mutated);
                        } else if (tabId == 'allReports') {
                            return Report.fromExistingData(mutated);
                        }
                        return undefined;
                    }
                ),
                tap(({loading}) => this.spinnerShow = loading),
                tap(
                    (body) => {
                        this.data[this.tabId].data = []; // I do not know why this is written here and I will not play with it yet
                        this.data[this.tabId].total = null; // I do not know why this is written here and I will not play with it yet
                        this.data[tabId].data = body.entities;
                        this.data[tabId].total = body.total;
                        this.emptyRowService.fillEmptyRow();
                        if ($('.table')[0])
                            $('.table')[0].scrollIntoView();
                    },
                    (error) => {
                        this.showServiceUnavailable = true;
                        this.spinnerShow = false;
                        this.api.errorHandler(error, 'Failed get Reports');
                    }
                )
            );
    }

    getReport(id) {
        const url = `/v1/reports/${id}.json`;
        this.api.get('domainReportGenerator', `${url}`).subscribe(
            (res) => {
                const body = JSON.parse(res._body);
                this.data.allReports.data.forEach((report, index) => {
                    if (report.id === id && body.status && (body.status !== report.status)) {
                        this.data.allReports.data[index].status = body.status;
                        this.data.allReports.data[index].links = body.links;
                    }
                });
            },
            (error) => this.api.errorHandler(error, 'Failed to report status')
        );
    }

    getBuildings(): void {
        if (this.buildings.length) return;
        const url = `/v1/buildings/short.json?per-page=10000&order-by=name|asc`;
        this.api.get('domainBD', url).subscribe(
            (res) => {
                this.buildings = JSON.parse(res._body).entities;
                this.buildingsForMultiselect = this.buildings.map(b => ({
                    ...b,
                    itemName: b.name
                }));
                this.getFilteredBuildings();
            },
            (error) => this.api.errorHandler(error, 'Failed get buildings')
        );
    }

    resetData() {
        for (const item in this.data) {
            this.data[item].data = [];
            this.data[item].total = null;
        }
    }

    deleteTemplate(template: ReportTemplate): void {
        if (!template.id) return;
        swal(ConstantsService.getSwalConfig('Delete Report Template'),
            () => {
                const url = `/v1/report_templates/${template.id}.json`;
                this.api.remove('domainReportGenerator', url).subscribe(
                    () => {
                        toastr.success('Report Template has been deleted.');
                        if (this.data.allTemplates.data.length - 1 == 0 && this.urlService.queryParams.page != '1')
                            this.urlService.queryParams.page = (parseInt(this.urlService.queryParams.page) - 1).toString();
                        this.getData();
                    },
                    (error) => this.api.errorHandler(error, 'Delete Report Template failed')
                );
            }
        );
    }

    checkIfTemplateHasRuntimeConditions(template) {
        //Check if template has runtime conditions
        if (template.conditions.length > 0 && template.conditions.filter(cond => cond.isRuntime).length > 0) {
            this.showRuntimeConditionsModal = true;
            this.templateInTemplateModal = JSON.parse(JSON.stringify(template));
        } else {
            this.templateInTemplateModal = JSON.parse(JSON.stringify(template));
            this.showReportNameModal = true;
        }
    }

    runReport(templateId, name) {
        const url = `/v1/reports/template-${templateId}`;
        const data = {name: name};

        this.api.post('domainReportGenerator', `${url}`, data).subscribe(
            res => {
                //go to the reports tab. Kill and launch the refresh function
                toastr.success('Report was successfully ran. Please wait for it to be prepared.');
                this.urlService.queryParams['order-by'] = null;
                this.urlService.setQueryParams('allReports');
                this.tabId = 'allReports';
            },
            error => this.api.errorHandler(error, 'Failed to run Report')
        );
    }

    deleteReport(report: Report): void {
        if (!report.id) return;
        swal(ConstantsService.getSwalConfig('Delete Report'),
            () => {
                const url = `/v1/reports/${report.id}.json`;
                this.api.remove('domainReportGenerator', url).subscribe(
                    () => {
                        toastr.success('Report has been deleted.');
                        if (this.data.allReports.data.length - 1 == 0 && this.urlService.queryParams.page != '1')
                            this.urlService.queryParams.page = (parseInt(this.urlService.queryParams.page) - 1).toString();
                        this.getData();
                    },
                    (error) => this.api.errorHandler(error, 'Delete Report failed')
                );
            }
        );
    }

    openTemplate(template, copy) {
        this.templateInTemplateModal = JSON.parse(JSON.stringify(template));
        this.copyingReport = copy;
        this.turnComponent('isReportModalShow');
    }

    viewTemplate(template) {
        this.viewOnlyMode = true;
        this.templateInTemplateModal = JSON.parse(JSON.stringify(template));
        this.turnComponent('isReportModalShow');
    }

    canEdit(buildingId?: number) {
        return this.account.canUpdate(this.serviceName, buildingId);
    }

    canDelete(buildingId?: number) {
        return this.account.canDelete(this.serviceName, buildingId);
    }

    getFilteredBuildings() {
        this.buildingsForRead = this.account.getBuildingsForRead(this.buildings, this.serviceName);
        this.buildingsForUpdate = this.account.getBuildingsForUpdate(this.buildings, this.serviceName);
    }

    turnComponent(property) {
        this.isReportModalShow = property == 'isReportModalShow';
        this.isListShow = property == 'isListShow';
    }
}

@Injectable()
export class ConfirmReportModalDeactivateGuard implements CanDeactivate<ReportGeneratorModalComponent> {
    canDeactivate(target: ReportGeneratorModalComponent): Observable<boolean> | boolean {
        if (target && target.reportGeneratorService.isReportModalShow && target.reportGeneratorService.modalInfoWasChanged) {
            return new Observable(observer => {
                swal(ConstantsService.getSwalConfig('Close without adding?', 'Your condition wasn\'t added. Are you sure you want to save the report template without the condition?'),
                    (value) => {
                        observer.next(value);
                    }
                );
            });
        } else
            return true;
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/report-generator.service.ts